import axios from '../axios-config.js';

/**
 * Envia o arquivo .xlsx oficial (CST + cClassTrib de IBS/CBS) para importação.
 * @param {FormData} formData — deve conter `file` (File, .xlsx)
 * @returns {Promise<{ arquivo, totalCst, totalCclasstrib, cstUpserted, cclassUpserted, erros, mensagensErro }>}
 */
export async function importCclasstribTable(formData) {
    const response = await axios.post('/admin/cclasstrib/import', formData, {
        headers: { 'Content-Type': 'multipart/form-data' },
    });
    return response.data;
}
